import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AssemblySourcingPage } from '@/areas/sourcing-scenarios/SourcingScenarios/AssemblySourcingPage/AssemblySourcingPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <AssemblySourcingPage {...pathParams} />;
}
